import { useEffect, useRef, useReducer } from "react";

import "./App.scss";
import { getRoutes, isAuthDomain } from "./common/utilities/routes/routes.util";
import { FirebaseAuthContainer } from "./common/containers/auth/firebase-auth-container.util";
import { ProvidersContainer } from "./common/containers/providers/providers.container";
import { ThemeContainer } from "./common/containers/theme/theme.container";
import { ToastProvider } from "./components/toast/toast.comp";
import { AuthDomainRoutes } from "./components/routes/auth-domain-routes.comp";
import { ChatSurfaceWiring } from "./common/containers/chat-surface/chat-surface.wiring";
import { DocumentTitle } from "./components/document-title.comp";

function App() {
    const { isTrial } = FirebaseAuthContainer.useContainer();
    const { logo, theme } = ThemeContainer.useContainer();

    // Detect if running on login domain
    const onAuthDomain = isAuthDomain();

    console.log(
        "App - isAuthDomain:",
        onAuthDomain,
        "pathname:",
        window.location.pathname,
        "hostname:",
        window.location.hostname
    );

    // Use login domain routes if on login domain, otherwise use tenant routes
    const AppRoutes = useRef<() => JSX.Element>(
        onAuthDomain ? AuthDomainRoutes : getRoutes(isTrial)
    );
    const [, render] = useReducer(p => !p, false);

    useEffect(() => {
        // Title is managed per-route by <DocumentTitle/> (WCAG 2.4.2); here we
        // only keep the favicon in sync with the active tenant logo.
        const favicon = document.querySelector("link[rel~='icon']");
        if (favicon && favicon instanceof HTMLLinkElement) {
            favicon.href = "favicon-mba.ico";
        }
    }, [logo]);

    useEffect(() => {
        document.documentElement.setAttribute("data-theme", theme);
    }, [theme]);

    useEffect(() => {
        // Only update routes for tenant domains (not login domain)
        if (!onAuthDomain) {
            AppRoutes.current = getRoutes(isTrial);
            render();
        }
    }, [isTrial, onAuthDomain]);

    // useEffect(() => {
    //     if (!devEnv) return;

    //     const app = getApp(devEnv);

    //     if (app) {
    //         AppRoutes.current = app.routes;
    //         render();
    //     }
    // }, [devEnv]);

    return (
        <ProvidersContainer.Provider>
            <DocumentTitle />
            <ToastProvider>
                <ChatSurfaceWiring>
                    <AppRoutes.current />
                </ChatSurfaceWiring>
            </ToastProvider>
        </ProvidersContainer.Provider>
    );
}

export default App;
